<span class="privilege-component">
  <button *ngIf="!checked" mat-icon-button aria-label="privilege?.character.title"
    class="privilege-component__button"
    (click)="checkBoxClicked()">
    <mat-icon class="privilege-component__button__icon">fiber_manual_record</mat-icon>
  </button>
  <img *ngIf="checked"
    class="privilege-component__image"
    [src]="main_domain + privilege?.character.icon"
    [title]="privilege?.character.title"
    (click)="checkBoxClicked()">
</span>
